import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useProject } from 'components/hooks';
import { scmType } from 'helpers';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { ProjectSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import ProjectFormDumb from './ProjectFormDumb';


const ProjectEditSmart = (props) => {
  const { match: { params } } = props;
  const { projectId } = params;
  const history = useHistory();
  const { cleanUpMessage, error, success, putProject, getProject, data, isLoaded } = useProject();
  const [foulderError, setFoulderError] = useState(false);

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    company: '',
    scmType: scmType[0].value,
    folder: '',
    scmUrl: '',
    scmBranch: '',
    scmRefspec: '',
    credential: '',
    clean: false,
    deleteOnUpdate: false,
    allowBranchOverride: false,
  });


  useEffect(() => {
    if (error.post == -2){
      setFoulderError(true);
    }
    
  }, [error.post]);


  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.PROJECT_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    const query = { projectId }
    getProject({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const project = new ProjectSchema();
    project.setValues(data);
    project.values.project_id = projectId;
    putProject({ body: project.getValues() });
  };



  function handleData() {
    const {
      base_url, 
      company_id, 
      name, 
      description, 
      type_scm,
      url_scm,
      branch_scm,
      refspec_scm,
      credentials_id,
      clean,
      clear_update,
      allow_branch_override
    } = data;
    const dataToSet = {
      name,
      description,
      company: company_id,
      scmType: type_scm,
      folder: base_url,
      scmUrl: url_scm,
      scmBranch: branch_scm,
      scmRefspec: refspec_scm,
      credential: credentials_id,
      clean: clean,
      deleteOnUpdate: clear_update,
      allowBranchOverride: allow_branch_override,
    }
    setDefaultValues(dataToSet);
  };

  useEffect(() => {
    if (error.put == -2){
      setFoulderError(true);
    }
    
  }, [error.put]);

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data) &&
        (
          <ProjectFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true} />
        )
      }
      {foulderError ? 
        <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.directory" />
       :
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
      }
    </>
  );
};

export default withRequest(withRouter(ProjectEditSmart));
